'use client';

import {
  Tooltip as AriaTooltip,

  composeRenderProps,
  Focusable,
  OverlayArrow,
  TooltipTrigger,
} from 'react-aria-components';
import type { TooltipProps as AriaTooltipProps } from 'react-aria-components';
import { tv } from 'tailwind-variants';

export type TooltipProps = {
  children: React.ReactNode;
} & Omit<AriaTooltipProps, 'children'>;

const styles = tv({
  base: 'group bg-tooltip-bg text-tooltip-text text-xs rounded-md shadow-lg px-2.5 py-1.5 max-w-xs',
  variants: {
    isEntering: {
      true: 'animate-in fade-in placement-bottom:slide-in-from-top-0.5 placement-top:slide-in-from-bottom-0.5 placement-left:slide-in-from-right-0.5 placement-right:slide-in-from-left-0.5 ease-out duration-200',
    },
    isExiting: {
      true: 'animate-out fade-out placement-bottom:slide-out-to-top-0.5 placement-top:slide-out-to-bottom-0.5 placement-left:slide-out-to-right-0.5 placement-right:slide-out-to-left-0.5 ease-in duration-150',
    },
  },
});

export function Tooltip({ children, ...props }: TooltipProps) {
  return (
    <AriaTooltip
      {...props}
      offset={10}
      className={composeRenderProps(props.className, (className, renderProps) =>
        styles({ ...renderProps, className }))}
    >
      <OverlayArrow>
        <svg
          width={8}
          height={8}
          viewBox="0 0 8 8"
          className="fill-tooltip-bg group-placement-bottom:rotate-180 group-placement-left:-rotate-90 group-placement-right:rotate-90"
        >
          <path d="M0 0 L4 4 L8 0" />
        </svg>
      </OverlayArrow>
      {children}
    </AriaTooltip>
  );
}

export { Focusable, TooltipTrigger };
